import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth, formatApiError } from "../lib/auth";
import { toast, Toaster } from "sonner";

export default function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const queryNext = new URLSearchParams(location.search).get("next");
    const next = queryNext || location.state?.from || "/designer";
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError("");
        try {
            const data = await login(email.trim(), password);
            toast.success("Welkom terug!");
            navigate(data.role === "admin" ? "/admin" : next, { replace: true });
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div data-testid="login-page" className="min-h-[80vh] grid place-items-center px-6 py-12 bg-zinc-50">
            <Toaster />
            <div className="w-full max-w-md card p-8">
                <p className="label-tiny">Inloggen</p>
                <h1 className="font-display text-4xl mt-2">Welkom terug.</h1>
                <p className="text-sm text-zinc-500 mt-2">Log in om door te gaan met ontwerpen.</p>

                <form onSubmit={onSubmit} className="mt-8 space-y-4">
                    <div>
                        <label className="label-tiny block mb-2">E-mail</label>
                        <input
                            data-testid="login-email-input"
                            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                            className="input-flat" placeholder="je@mail.be"
                        />
                    </div>
                    <div>
                        <label className="label-tiny block mb-2">Wachtwoord</label>
                        <input
                            data-testid="login-password-input"
                            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                            className="input-flat" placeholder="••••••••"
                        />
                    </div>
                    {error && <p data-testid="login-error" className="text-sm text-rose-600">{error}</p>}
                    <button data-testid="login-submit-button" type="submit" disabled={submitting} className="btn-primary w-full">
                        {submitting ? "Bezig..." : "Inloggen"}
                    </button>
                </form>

                <p className="text-sm text-zinc-500 mt-6 text-center">
                    Nog geen account? <Link data-testid="login-go-register" to="/register" className="underline">Registreer</Link>
                </p>
                <p className="text-sm text-zinc-500 mt-2 text-center">
                    <Link data-testid="login-forgot-password" to="/forgot-password" className="underline">Wachtwoord vergeten?</Link>
                </p>
            </div>
        </div>
    );
}
